import { useEffect, useRef } from 'react';
import { useBreadcrumbStore, BreadcrumbItem } from '@/client/stores/breadcrumb';

export const useBreadcrumbs = (items: BreadcrumbItem[]) => {
  const setBreadcrumbs = useBreadcrumbStore((state) => state.setBreadcrumbs);
  const resetBreadcrumbs = useBreadcrumbStore((state) => state.resetBreadcrumbs);
  
  useEffect(() => {
    // Check if the store needs updating
    // We access the store directly to avoid dependency loops or stale closures
    const currentBreadcrumbs = useBreadcrumbStore.getState().breadcrumbs;
    const itemsJson = JSON.stringify(items);
    const currentJson = JSON.stringify(currentBreadcrumbs);

    if (itemsJson !== currentJson) {
      setBreadcrumbs(items);
    }

    // Cleanup on unmount
    return () => {
      resetBreadcrumbs();
    };
  }, [items, setBreadcrumbs, resetBreadcrumbs]);
};
